module.exports = __webpack_public_path__ + "static/LTC_Courses_Brazos_County-17e3e66eababa5c8dd9a7c62305ccc95.jpg";